const ModalsComponent = {
    data() {
        return {
            // локальная реактивная копия
            activeModal: window.globalState?.activeModal ?? null,
            modalPayload: window.globalState?.modalPayload ?? null,

            // формы / состояния
            message: "",
            messageError: "",
            errors: {},
            loading: false,

            notifications: [],

            rating: 0,

            // internals for cleanup
            _eventListeners: [],
            _modalCallback: null,
            _authCallback: null,
            _notificationCallback: null
        };
    },

    computed: {
        isModalOpen() {
            return this.activeModal !== null;
        },
        modalData() {
            return this.modalPayload || {};
        }
    },

    methods: {
        /* ---------- MODAL CONTROL ---------- */
        openModal(modalName, payload) {
            if (window.globalState && typeof window.globalState.openModal === 'function') {
                window.globalState.openModal(modalName, payload);
            } else {
                this.activeModal = modalName;
                this.modalPayload = payload;
                document.body.style.overflow = 'hidden';
            }
            if (!this.isBlocked) this.clearErrors();
        },

        closeModal() {
            if (window.globalState && typeof window.globalState.closeModal === 'function') {
                window.globalState.closeModal();
            } else {
                this.activeModal = null;
                document.body.style.overflow = '';
            }
            this.clearErrors();
        },

        clearErrors() {
            this.errors = {};
            this.message = "";
            this.messageError = "";
        },

        /* ---------- UTILS: doc listeners for easy cleanup ---------- */
        addDocListener(event, handler) {
            document.addEventListener(event, handler);
            this._eventListeners.push({event, handler});
        },

        removeAllListeners() {
            this._eventListeners.forEach(({event, handler}) => {
                document.removeEventListener(event, handler);
            });
            this._eventListeners = [];
        },

        /* ---------- FEEDBACK ---------- */
        async sendReview() {
            this.loading = true;
            this.clearErrors();

            try {
                const form_data = new FormData(document.getElementById('formReview'));

                /**
                 * Передаём payload
                 */
                form_data.append('userId', this.modalPayload);

                const response = await fetch(window.appConfig.routes.reviewSend, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json'
                    },
                    body: form_data
                });

                const data = await response.json();

                if (response.ok) {
                    this.openModal("reviewSuccess");
                } else if (response.status === 422) {
                    this.errors = data;
                    globalState.addNotification(
                        `Пожалуйста, заполните все необходимые поля.`
                    );
                } else {
                    this.messageError = data.message || "В ходе отправки произошла ошибка";
                }
            } catch (error) {
                this.messageError = "Ошибка сети. Попробуйте еще раз.";
            } finally {
                this.loading = false;
            }
        },

        initRating() {
            const self = this;

            $("#rateYo").rateYo({
                rating: 0,
                fullStar: true,
                starWidth: "28px",
                spacing: "4px",
                ratedFill: "#ffb400",
                normalFill: "#dfe1e4",
            })
                .on("rateyo.set", function (e, data) {

                    /**
                     * Сохраняем выбранный рейтинг
                     */
                    self.rating = data.rating;
                });
        },

        addToCalendar() {
            const data = this.modalData || {};

            if (!data.dateRaw || !data.time) {
                console.error('No date/time for calendar');
                return;
            }

            const params = new URLSearchParams({
                date: data.dateRaw,
                time: data.time,
                duration: data.duration || 60,
                doctor: data.doctor || '',
                address: data.address || ''
            });

            window.location.href = `/calendar/ics?${params.toString()}`;
        },

        async sendProgram() {
            this.loading = true;
            this.clearErrors();

            try {
                const form_data = new FormData(document.getElementById('formProgram'));

                /**
                 * Передаём payload
                 */
                form_data.append('programTitle', this.modalPayload);

                const response = await fetch(window.appConfig.routes.sendProgram, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json'
                    },
                    body: form_data
                });

                const data = await response.json();

                if (response.ok) {
                    this.openModal("reviewSuccess");
                } else if (response.status === 422) {
                    this.errors = data;
                    globalState.addNotification(
                        `Пожалуйста, заполните все необходимые поля.`
                    );
                } else {
                    this.messageError = data.message || "В ходе отправки произошла ошибка";
                }
            } catch (error) {
                this.messageError = "Ошибка сети. Попробуйте еще раз.";
            } finally {
                this.loading = false;
            }
        },

    },

    mounted() {

        // register modal change callback (legacy globalState uses window.modalChangeCallbacks)
        this._modalCallback = (modalName, payload) => {
            this.activeModal = modalName;
            this.modalPayload = payload ?? null;
        };
        window.globalState.onModalChange(this._modalCallback);

        // register notifications callback
        this._notificationCallback = (n) => {
            this.notifications = n;
        };
        window.globalState.onNotificationChange(this._notificationCallback);

        // global click open handler (delegation)
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('.js-open-modal');
            if (!btn) return;
            e.preventDefault();
            const modalName = btn.dataset.modal;
            const modalPayload = btn.dataset.payload;
            console.log(modalPayload);
            this.openModal(modalName, modalPayload);
        });

        // backdrop close detection
        let mouseDownTarget = null;
        document.addEventListener('mousedown', (e) => {
            mouseDownTarget = e.target;
        });
        document.addEventListener('mouseup', (e) => {
            if (mouseDownTarget &&
                mouseDownTarget.classList.contains('modal-wrapper') &&
                e.target.classList.contains('modal-wrapper') &&
                this.activeModal) {
                this.closeModal();
            }
            mouseDownTarget = null;
        });

        // ESC close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.activeModal) this.closeModal();
        });
    },

    beforeUnmount() {
        // remove callbacks from global arrays
        if (window.modalChangeCallbacks) {
            window.modalChangeCallbacks = window.modalChangeCallbacks.filter(cb => cb !== this._modalCallback);
        }
        if (window.notificationChangeCallbacks) {
            window.notificationChangeCallbacks = window.notificationChangeCallbacks.filter(cb => cb !== this._notificationCallback);
        }
    },

    watch: {
        activeModal(newVal) {
            if (newVal === 'review') {
                this.$nextTick(() => {
                    this.initRating();
                });
            }
        }
    },
};

window.ModalsComponent = ModalsComponent;